import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Stack } from '@mui/material';
import { darken } from '@mui/system/colorManipulator';

type SidebarBodyMenuProps = {
  isCollapsed: boolean;
  onCollapsed: (isCollapsed: boolean) => void;
};

export const ButtonCollapsed = (props: SidebarBodyMenuProps) => {
  const { isCollapsed, onCollapsed } = props;
  return (
    <Stack
      sx={{
        position: 'absolute',
        backgroundColor: t => t.palette.background.paper,
        borderRadius: '50%',
        p: 1,
        left: 0,
        transform: `translateX(${isCollapsed ? 50 : 281}px)`,
        top: 10,
        cursor: 'pointer',
        transition: '0.5s transform ease',
        zIndex: 1000,
        color: 'inherit',
        '&:hover': {
          backgroundColor: t => darken(t.palette.background.paper, 0.1),

          boxShadow: t =>
            `0px 1px 4px 0px ${darken(t.palette.background.paper, 0.2)}`,
        },
      }}
      onClick={() => {
        onCollapsed(!isCollapsed);
      }}
    >
      <ArrowForwardIosIcon
        fontSize="small"
        sx={{
          color: 'inherit',
          transition: '0.5s transform ease',
          transform: `rotate(${isCollapsed ? 0 : 180}deg)`,
        }}
      />
    </Stack>
  );
};
